"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.classNames = void 0;
var tslib_1 = require("tslib");
/**
 * The `classNames` function allows you to dynamically create class name strings based on boolean operators
 * @param args strings or an object of class names [key] and a boolean [value] as to whether they should be used or not
 * @returns {string} the string of class names
 */
var classNames = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var names = args.reduce(function (acc, curr) {
        if (typeof curr === 'object') {
            return tslib_1.__spreadArray(tslib_1.__spreadArray([], acc, true), Object.entries(curr)
                .map(function (_a) {
                var key = _a[0], value = _a[1];
                return value ? key : undefined;
            })
                .filter(Boolean), true);
        }
        return tslib_1.__spreadArray(tslib_1.__spreadArray([], acc, true), [
            curr
        ], false);
    }, []);
    return names.filter(Boolean).join(' ');
};
exports.classNames = classNames;
//# sourceMappingURL=classnames.js.map